// Global styling constants for the innovation days demo
export const CARD_TITLE_CLASSES =
  "text-[18px] leading-[28px] font-semibold text-[#0F172A] overflow-hidden text-ellipsis";
export const BODY_TEXT_COLOR = "#0F172A";
